import { Component, Input, OnInit, SimpleChange, TemplateRef, ViewChild, NgZone } from '@angular/core';
import { first, Subscription } from 'rxjs';
import { AutomationService } from 'src/app/services/automation.service';
import { DeviceService } from 'src/app/services/device.service';
import { LogcatService } from 'src/app/services/logcat.service';
import * as _ from 'lodash';
import { GroupService } from 'src/app/services/group.service';
import { Router } from '@angular/router';
import { ControlService } from 'src/app/services/control.service';
import { StackService } from 'src/app/services/stack-service.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DeviceScalingService } from 'src/app/services/device-scaling.service';
import * as L from 'leaflet';
import { OpenStreetMapProvider } from 'leaflet-geosearch';
import { CommonService } from 'src/app/services/common.service';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DeviceContextMenuComponent } from './device-context-menu/device-context-menu.component';
import { DeviceScreenComponent } from './device-screen/device-screen.component';

@Component({
  selector: 'app-device-control',
  templateUrl: './device-control.component.html',
  styleUrls: ['./device-control.component.css'],
  standalone: true,
  imports: [TranslateModule, CommonModule, FormsModule, DeviceContextMenuComponent, DeviceScreenComponent]
})
export class DeviceControlComponent implements OnInit {
  isScreenRotated: boolean = false;
  private sub!: Subscription;
  scaledDimensions: { width: number, height: number, scale: number };
  @Input() device: any;
  @Input() control: ControlService;
  modalRef!: MatDialogRef<any>;
  showScreen: boolean = true;
  renderChildComponent: boolean = false;
  @ViewChild('alerttemplate') alertTemplate!: TemplateRef<any>;
  msg: string = "";
  bridgeHost: any;
  groupTracker: any;
  groupDevices: any;
  appInspectorPort: any;
  appInspectbridgeHostorUrl: any;
  currentRotation: any;
  cursor: string = 'wait';
  fullView: boolean = false;
  showCoordinates: boolean = false;
  isNavbar = false;
  showThrottleOptions = false;

  throttleOptions: { label: string, value: number }[] = [
    { label: 'No limit', value: 0 },
    { label: '128kbps', value: 16000 },
    { label: '256kbps', value: 32000 },
    { label: '1mbps', value: 125000 },
    { label: '5mbps', value: 625000 },
    { label: '15mbps', value: 1875000 }
  ];
  geoTestingEnabled = false;
  map!: L.Map;
  marker!: L.Marker;
  lat: number = 20.0;
  lng: number = 0.0;

  toggleStates: { [key: string]: boolean } = {};

  toggle(key: string) {
    this.toggleStates[key] = !this.toggleStates[key];
    switch (key) {
      case 'coordinates': this.showCords(); break;
      case 'throttle': this.toggleThrottleOptions(); break;
      case 'geolocation': this.toggleGeoTesting(); break;
    }
  }

  constructor(
    private deviceService: DeviceService,
    private logcatService: LogcatService,
    private automationService: AutomationService,
    private groupService: GroupService,
    private router: Router,
    private stackService: StackService,
    private dialog: MatDialog,
    private deviceScalingService: DeviceScalingService,
    private ngZone: NgZone,
    private commonService: CommonService
  ) {
  }

  ngOnInit(): void {
    window.onbeforeunload = null;

    this.sub = this.deviceService.isScreenRotated$.subscribe(value => {
      this.isScreenRotated = value;
    });
    this.renderChildComponent = true;

    this.currentRotation = 'portrait';

    this.groupTracker = this.deviceService.trackGroup();
    this.groupDevices = this.groupTracker.devices
  }

  fullViewDevice() {
    this.fullView = !this.fullView;
  }

  handleChildData(data: string) {
    this.cursor = data;
  }

  checkScreen() {
    this.showScreen = !this.showScreen;
  }

  kickDevice(device: any, force?: boolean) {
    this.stackService.delete(device.serial);
    if (Object.keys(this.logcatService.deviceEntries).includes(device.serial)) {
      this.logcatService.deviceEntries[device.serial].allowClean = true;

      this.bridgeHost = device.providerUrl;
      this.automationService.stopAppInspector(this.appInspectorPort, this.device.serial, this.bridgeHost).pipe(first()).subscribe((res: any) => {
        this.appInspectbridgeHostorUrl = null;
        sessionStorage.setItem("appInspectorUrl", null)
      });
    }

    // $scope.LogcatService = LogcatService
    // $rootScope.LogcatService = LogcatService

    if (!device || !this.device) {
      this.msg = "No device found";
      this.openAlertMod(this.alertTemplate, this.msg);
      // alert('No device found')
      return;
    }

    try {
      // If we're trying to kick current device
      if (device.serial === this.device.serial) {

        // If there is more than one device left
        if (this.groupDevices.length > 1) {

          // Control first free device first
          let firstFreeDevice = _.find(this.groupDevices, (dev: any) => {
            return dev.serial !== this.device.serial
          })

          this.controlDevice(firstFreeDevice);

          // Then kick the old device
          this.groupService.kick(device, force).then(() => {
            // $scope.$digest()
          })
        } else {
          // Kick the device
          this.groupService.kick(device, force).then(() => {
            // $scope.$digest()
          })
          // $location.path('/devices/')
          this.commonService.setActiveTab('/devices');
          this.router.navigate(['/devices']);
        }
      } else {
        this.groupService.kick(device, force).then(() => {
          // $scope.$digest()
        })
      }
    } catch (e) {
      this.msg = e.message;
      this.openAlertMod(this.alertTemplate, this.msg);

      // alert(e.message)
    }
  }

  sendScrollUp() {
    if (this.device.ios)
      this.control.keyPress('swipeUp');
    else
      this.control.shell('input swipe 500 800 500 1300')
  }

  sendScrollDown() {
    if (this.device.ios)
      this.control.keyPress('swipeDown');
    else
      this.control.shell('input swipe 500 1300 500 800')
  }

  press(key) {
    this.control.keyPress(key)
  }

  key(key: any) {
    if (this.device.ios) {
      this.control.keyPress(key);
      return
    }
    this.control.keyDown(key)
    this.control.keyUp(key)
  }

  back(key: any) {
    if (this.device.ios) {
      this.control.keyPress('goBack');
      return
    }
    this.control.keyDown(key)
    this.control.keyUp(key)
  }
  // hitesh
  showCords() {
    this.showCoordinates = !this.showCoordinates;
  }

  controlDevice(device: any) {
    this.commonService.setActiveTab('/devices');
    this.router.navigate(['/devices']);
    // this.router.navigate(['/control', device.serial]);
  }

  isPortrait(val?: any) {
    let value = val;
    if (typeof value === 'undefined' && this.device) {
      value = this.device.display.rotation;
    }
    return (value === 0 || value === 180);
  }

  isLandscape(val?: any) {
    let value = val;
    if (typeof value === 'undefined' && this.device) {
      value = this.device.display.rotation;
    }
    return (value === 90 || value === 270);
  }

  tryToRotate(rotation: any) {
    if (rotation === 'portrait') {
      this.control.rotate(0);
      setTimeout(() => {
        if (this.isLandscape()) {
          this.currentRotation = 'landscape';
        }
      }, 400)
    } else if (rotation === 'landscape') {
      this.control.rotate(90);
      setTimeout(() => {
        if (this.isPortrait()) {
          this.currentRotation = 'portrait';
        }
      }, 400)
    }
  }

  rotateLeft() {
    let angle = 0
    if (this.device && this.device.display) {
      angle = this.device.display.rotation;
    }
    if (angle === 0) {
      angle = 270
    } else {
      angle -= 90
    }
    this.control.rotate(angle);

    // if ($rootScope.standalone) {
    //   $window.resizeTo($window.outerHeight, $window.outerWidth)
    // }
  }

  rotateRight() {
    let angle = 0
    if (this.device && this.device.display) {
      angle = this.device.display.rotation;
    }
    if (angle === 270) {
      angle = 0
    } else {
      angle += 90
    }
    this.control.rotate(angle);

    // if ($rootScope.standalone) {
    //   $window.resizeTo($window.outerHeight, $window.outerWidth)
    // }
  }
  openAlertMod(template: TemplateRef<any>, message: any) {
    this.modalRef = this.dialog.open(template, { width: '300px' });
    this.msg = message;
    setTimeout(() => {
      this.modalRef.close();;
      this.msg = "";
    }, 2000)
  }

  Ok() {
    this.modalRef.close();;
    this.msg = "";
  }

  toggleThrottleOptions(): void {
    // setTimeout(() => {
    this.showThrottleOptions = !this.showThrottleOptions;
    // }, 0);
  }

  applyThrottle(option: { label: string, value: number }): void {
    if (!this.device && !this.device.ios) {
      this.msg = 'No device information available';
      this.openAlertMod(this.alertTemplate, this.msg);
      return;
    }

    const androidVersion = parseFloat(this.device.version || '0');

    if (!androidVersion || androidVersion < 13) {
      this.msg = 'Throttling is not supported on this device. Android 13 or higher is required.';
      this.openAlertMod(this.alertTemplate, this.msg);
      return;
    }

    let command = `settings put global ingress_rate_limit_bytes_per_second ${option.value}`;
    this.control.shell(command);
    this.msg = `Throttle set to ${option.label}`;
    this.openAlertMod(this.alertTemplate, this.msg);
    this.toggleThrottleOptions();
    this.toggleStates['throttle'] = false;
  }

  toggleGeoTesting(): void {
    this.geoTestingEnabled = !this.geoTestingEnabled;
    delete (L.Icon.Default.prototype as any)._getIconUrl;

    L.Icon.Default.mergeOptions({
      iconRetinaUrl: 'assets/leaflet/marker-icon-2x.png',
      iconUrl: 'assets/leaflet/marker-icon.png',
      shadowUrl: 'assets/leaflet/marker-shadow.png',
    });
    if (this.geoTestingEnabled) {
      setTimeout(() => this.loadMap(), 0);
    }
  }

  loadMap(): void {
    const defaultLatLng: L.LatLngExpression = [this.lat, this.lng];

    this.map = L.map('map').setView(defaultLatLng, 2);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; OpenStreetMap contributors'
    }).addTo(this.map);

    this.marker = L.marker(defaultLatLng, { draggable: true }).addTo(this.map);

    // When marker is dragged
    this.marker.on('dragend', (event: any) => {
      const position = event.target.getLatLng();
      this.ngZone.run(() => {
        this.lat = position.lat;
        this.lng = position.lng;
      });
    });

    // When user clicks on map
    this.map.on('click', (e: L.LeafletMouseEvent) => {
      this.ngZone.run(() => {
        this.lat = e.latlng.lat;
        this.lng = e.latlng.lng;
        this.marker.setLatLng(e.latlng);
      });
    });

    this.initSearchBox();
  }


  initSearchBox(): void {
    const input = document.getElementById('search-box') as HTMLInputElement;
    const provider = new OpenStreetMapProvider();

    input.addEventListener('keydown', async (event: KeyboardEvent) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        const query = input.value;
        const results = await provider.search({ query });
        if (results.length > 0) {
          const loc = results[0];
          this.ngZone.run(() => {
            this.lat = loc.y;
            this.lng = loc.x;
            const latLng = L.latLng(this.lat, this.lng);
            this.map.setView(latLng, 14);
            this.marker.setLatLng(latLng);
          });
        }
      }
    });
  }

  sendLocation(): void {
    if (this.lat == null || this.lng == null) {
      this.msg = ' Please select a location first.';
      this.openAlertMod(this.alertTemplate, this.msg);
      return;
    }

    if (this.device.ios) {
      Promise.resolve().then(() => {
        this.control.geoLocation(
          this.lat,
          this.lng
        );

        this.msg = ` iOS mock location set to: ${this.lat}, ${this.lng}`;
        this.openAlertMod(this.alertTemplate, this.msg);
        this.geoTestingEnabled = false;
      }).catch((err: any) => {
        console.error(err);
        this.msg = ' Failed to send mock location on iOS.';
        this.openAlertMod(this.alertTemplate, this.msg);
      });
    } else {
      // Android via ADB
      const cmd = `am startservice -n io.appium.settings/.LocationService -a io.appium.settings.location --es longitude ${this.lng} --es latitude ${this.lat}`;

      this.control.shell(cmd)
        .then(() => {
          this.msg = ` Android mock location set to: ${this.lat}, ${this.lng}`;
          this.openAlertMod(this.alertTemplate, this.msg);
          this.geoTestingEnabled = false;
        })
        .catch((err: any) => {
          console.error(err);
          this.msg = 'Failed to send mock location via ADB.';
          this.openAlertMod(this.alertTemplate, this.msg);
        });
    }
    this.toggleStates['geolocation'] = false;
  }
}







